<template>
    <div id="select" @click="optionsVisible = !optionsVisible" v-click-outside="hideOptions">
        <p v-if="selected != ''">{{ selected }}</p>
        <p v-else id="unselected">{{ title }}</p>
        <svg id="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#051C2E"><path d="m12 15-5-5h10Z"/></svg>
    </div>
    <div id="options" v-show="optionsVisible">
        <div v-for="option in options" :key="option" @click="selectOption(option)">
            <p>{{ option }}</p>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CustomSelect',
    props: {
        title: String,
        options: Array,
        
    },
    emits: ['option-selected'],
    data() {
        return {
            selected: '',
            optionsVisible: false
        }
    },
    methods: {
        selectOption(str) {
            this.selected = str;
            this.optionsVisible = false;
            this.$emit('option-selected', this.selected);
        },
        hideOptions() {
            this.optionsVisible = false;
        }
    }
}
</script>

<style scoped>

#select, #options div {
    min-width: 10rem;
    cursor: pointer;
}

#select {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--black);
}

#select svg, #select p {
    padding: 0 0.6rem;
}

#unselected {
    color: var(--gray);
}

#options {
    background-color: var(--white);
    position: absolute;
    margin-top: 3.5rem;
    box-shadow: 0 0 10px 0 var(--shadow);
}

#options p {
    margin: 0;
    padding: 0.6rem;
}

#options div:hover {
    background-color: var(--blue-selected);
}

</style>